import React, { useCallback, useState } from 'react'
import { Autosuggest } from '../../Common'
import { useStoresContext } from '../stores.context'
import { useLocalLabels } from '@sentecacommerce-theme/lib'
import { StoreLabels } from '../stores.props'

export const CitySelector = () => {
  const { selectedCity, cities, reset, filterByCity } = useStoresContext()

  const [citiesToShow, setCitiesToShow] = useState(cities)

  const filterCities = useCallback(
    (query: string) => {
      setCitiesToShow(
        !query ? cities : cities.filter((city) => city.includes(query))
      )
    },
    [cities]
  )

  const labels = useLocalLabels<StoreLabels>()

  return (
    <Autosuggest
      options={citiesToShow}
      selectedOption={selectedCity || undefined}
      getValue={(city: string) => city}
      getLabel={(city: string) => city}
      onOptionSelect={filterByCity}
      onRemove={reset}
      minLength={0}
      debounceDelay={0}
      updateOptions={filterCities}
      isFetching={false}
      withRemoveIconWhenSelected
      hideCheck
      placeholder={labels.cityInputPlaceholder}
    />
  )
}
